"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactSlots = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _utils = require("../../../lib/utils");
var _styles = require("../../styles");
const propTypes = {
  linkTarget: _propTypes.string,
  onTimeSlotsClick: _propTypes.func,
  providerId: _propTypes.number.isRequired,
  shouldDisplayAsOnMobile: _propTypes.bool,
  slotsData: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    href: _propTypes.string,
    time: _propTypes.string.isRequired,
    unformattedDate: _propTypes.string.isRequired
  })), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    count: _propTypes.number,
    unformattedDate: _propTypes.string.isRequired
  })), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    time: _propTypes.string.isRequired,
    href: _propTypes.string,
    unformattedDate: _propTypes.string.isRequired
  }))]).isRequired,
  locationName: _propTypes.string,
  slotsAriaLabel: _propTypes.func,
  slotsAriaDescribedBy: _propTypes.string,
  availabilityCountMessage: _propTypes.func,
  shouldRenderSlotsAsButtons: _propTypes.bool,
  slotsAriaHasPopup: _propTypes.string,
  slotsAriaControls: _propTypes.string,
  slotsAriaExpanded: _propTypes.bool,
  tileSize: (0, _propTypes.oneOf)(['small', 'large'])
};
const defaultProps = {
  linkTarget: null,
  onTimeSlotsClick: () => {},
  slotsAriaLabel: () => undefined,
  shouldRenderSlotsAsButtons: false,
  // real message to be translated by consumer
  availabilityCountMessage: count => `${count} appt${count > 1 ? 's' : ''}`
};
const CompactSlots = _ref => {
  let {
    linkTarget,
    onTimeSlotsClick,
    providerId,
    slotsData,
    locationName,
    slotsAriaLabel,
    slotsAriaDescribedBy,
    slotsAriaHasPopup,
    slotsAriaControls,
    slotsAriaExpanded,
    availabilityCountMessage,
    shouldRenderSlotsAsButtons,
    tileSize
  } = _ref;
  return (0, _map.default)(slotsData).call(slotsData, _ref2 => {
    let {
      date,
      href,
      time,
      count,
      unformattedDate
    } = _ref2;
    let ariaLabel = slotsAriaLabel(date, time, locationName);
    if (count != null) {
      ariaLabel = slotsAriaLabel(date, time, locationName, count);
    }
    let linkProps = {};
    if (!shouldRenderSlotsAsButtons) {
      linkProps = {
        href,
        target: linkTarget,
        rel: (0, _utils.getLinkRel)(linkTarget)
      };
    }
    return /*#__PURE__*/_react.default.createElement(_styles.CompactSlot, (0, _extends2.default)({
      key: `${unformattedDate}${time ?? ''}${count ?? ''}`,
      as: shouldRenderSlotsAsButtons ? 'button' : 'a',
      onClick: event => onTimeSlotsClick(date, time, providerId, href, unformattedDate, event),
      "aria-label": ariaLabel,
      "aria-haspopup": slotsAriaHasPopup,
      "aria-controls": slotsAriaControls,
      "aria-expanded": slotsAriaExpanded,
      "aria-describedby": slotsAriaDescribedBy,
      mode: "primary",
      tileSize: tileSize
    }, linkProps), /*#__PURE__*/_react.default.createElement("span", null, date != null && /*#__PURE__*/_react.default.createElement("span", null, date), time != null && /*#__PURE__*/_react.default.createElement("span", null, time), count != null && /*#__PURE__*/_react.default.createElement("span", null, availabilityCountMessage(count))));
  });
};
exports.CompactSlots = CompactSlots;
CompactSlots.defaultProps = defaultProps;
CompactSlots.propTypes = propTypes;